import React from 'react';

import BuildDetailsCwebExplorerLink from '../components/BuildDetailsCwebExplorerLink';
import BuildDetailsGrid, { BuildDetailsGridLabelValuePair } from '../components/BuildDetailsGrid';

import { L2ContractDetailsModule } from './BuildDetailsTokenInfoL2ContractModule';
import BuildDetailsTokenInfoL2ContractModuleInstanceParameters from './BuildDetailsTokenInfoL2ContractModuleInstanceParameters';

const BuildDetailsTokenInfoL2ContractModuleInstance: React.FC<{
  module: L2ContractDetailsModule;
}> = ({ module }) => {
  if (!module?.instance) return null;

  const { alias, instance_id: instanceId } = module.instance;

  return (
    <>
      <li className="mt-2">
        <BuildDetailsGrid>
          <span className="text-muted-foreground">Instance</span>
        </BuildDetailsGrid>
      </li>
      <li>
        <BuildDetailsGrid>
          <BuildDetailsGridLabelValuePair label="Alias" value={alias} />
        </BuildDetailsGrid>
      </li>
      <li>
        <BuildDetailsGrid>
          <BuildDetailsGridLabelValuePair
            label="Contract Instance"
            value={<BuildDetailsCwebExplorerLink id={instanceId} />}
          />
        </BuildDetailsGrid>
      </li>
      <li>
        <BuildDetailsTokenInfoL2ContractModuleInstanceParameters module={module} />
      </li>
    </>
  );
};

export default BuildDetailsTokenInfoL2ContractModuleInstance;
